export default __webpack_public_path__ + "8f9f1a3238b65f638589a8e57032079c.png";